import React from 'react';
import { Card } from 'antd';
import contactImage from '../../../assets/images/misc/contact.png';

const VanTrustContactInfo = () => {
  const image = <img alt="laptop" src={contactImage} />;

  return (
    <Card cover={image}>
      <p>En VanTrust queremos estar junto a ti para poder ofrecerte el mejor servicio.</p>
      <p style={{ marginBottom: 0 }}>Si necesitas información contáctanos aquí.</p>
      <a to="mailto:contacto@vantrust.cl">
        <b>contacto@vantrust.cl</b>
      </a>
    </Card>
  );
};

export default VanTrustContactInfo;
